import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_3 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_4 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_5 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_6 = {
  key: 4,
  class: "tab-content"
}
const _hoisted_7 = {
  key: 5,
  class: "tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_GridIndustrii = _resolveComponent("GridIndustrii")!
  const _component_GridSalesSources = _resolveComponent("GridSalesSources")!
  const _component_GridZileDisponibilitate = _resolveComponent("GridZileDisponibilitate")!
  const _component_GridTipuriActivitati = _resolveComponent("GridTipuriActivitati")!
  const _component_GridCampaniiMarketing = _resolveComponent("GridCampaniiMarketing")!
  const _component_GridTarget = _resolveComponent("GridTarget")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_GridTargetPeUser = _resolveComponent("GridTargetPeUser")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxTabs, {
      "data-source": $data.tabs,
      "selected-index": $data.selectedIndex,
      onOptionChanged: $options.onTabChanged,
      orientation: "vertical",
      class: "tabs",
      "item-template": $options.tabTemplate
    }, null, 8, ["data-source", "selected-index", "onOptionChanged", "item-template"]),
    ($data.selectedIndex === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_GridIndustrii)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_GridSalesSources)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_GridZileDisponibilitate)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_GridTipuriActivitati)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_GridCampaniiMarketing)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex === 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "7" }, {
                default: _withCtx(() => [
                  _createVNode(_component_GridTarget, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_GridTargetPeUser, { TargetID: $data.selectedRow }, null, 8, ["TargetID"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}